import { PropsWithChildren } from "react";
import { InputText, Span } from "@goodfill/ui-components";
import { AccountInformation } from "@goodfill/domain-customer-application-types";

interface Props {
  accountInformation: AccountInformation;
}

type FieldProps = PropsWithChildren<{
  label: string;
}>;

const Field: React.FC<FieldProps> = ({ children, label }) => {
  return (
    <div className="flex-col md:flex-row border-b border-neutral-110 justify-between items-center gap-2 md:gap-4">
      <div className="field-label">
        <Span font="light" size="sm">
          {label}
        </Span>
      </div>
      {children}
    </div>
  );
};

export const TradingPermissionsSection: React.FC<Props> = ({ accountInformation }) => {
  return (
    <div className="page-account-info-trading-permissions">
      <div className="flex">
        <div className="flex flex-col my-1 md:my-2 mx-4 md:mx-8 px-4 md:px-8 gap-4 md:gap-8">
          <div className="flex flex-col">
            <div className="flex items-center justify-between my-2 md:my-4">
              <Span font="semibold" size="lg">
                Investment Objectives
              </Span>
            </div>
            <div className="flex flex-col px-1 md:px-2">
              <Field label="Objectives">
                <InputText
                  neutral={true}
                  // placeholder="salutation"
                  value={accountInformation.investmentObjectives.map((objective) => {
                    return `${objective.charAt(0).toUpperCase()}${objective.slice(1)}`;
                  })}
                  // setValue={setName}
                  disabled={true}
                />
              </Field>
            </div>
          </div>

          <div className="flex flex-col">
            <div className="flex items-center justify-between my-2 md:my-4">
              <Span font="semibold" size="lg">
                Permissions
              </Span>
            </div>
            <div className="flex flex-col px-1 md:px-2">
              <Field label="Allow Bond Trading">
                <InputText
                  neutral={true}
                  // placeholder="salutation"
                  value={accountInformation.permissions.allowBondTrading ? "Yes" : "No"}
                  // setValue={setName}
                  disabled={true}
                />
              </Field>
            </div>
            <div className="flex flex-col px-1 md:px-2">
              <Field label="Allow Changing Account Information After User Instruction">
                <InputText
                  neutral={true}
                  // placeholder="salutation"
                  value={
                    accountInformation.permissions.allowChangingAccountInformationAfterUserInstruction ? "Yes" : "No"
                  }
                  // setValue={setName}
                  disabled={true}
                />
              </Field>
            </div>
            <div className="flex flex-col px-1 md:px-2">
              <Field label="Allow Transmitting Received Orders">
                <InputText
                  neutral={true}
                  // placeholder="salutation"
                  value={accountInformation.permissions.allowTransmittingReceivedOrders ? "Yes" : "No"}
                  // setValue={setName}
                  disabled={true}
                />
              </Field>
            </div>
            <div className="flex flex-col px-1 md:px-2">
              <Field label="Allow Confirmation Account Information">
                <InputText
                  neutral={true}
                  // placeholder="salutation"
                  value={accountInformation.permissions.allowConfirmingAccountInformation ? "Yes" : "No"}
                  // setValue={setName}
                  disabled={true}
                />
              </Field>
            </div>
            <div className="flex flex-col px-1 md:px-2">
              <Field label="Allow Responding to Tenders">
                <InputText
                  neutral={true}
                  // placeholder="salutation"
                  value={accountInformation.permissions.allowRespondingToTenders ? "Yes" : "No"}
                  // setValue={setName}
                  disabled={true}
                />
              </Field>
            </div>
            <div className="flex flex-col px-1 md:px-2">
              <Field label="Allow Responding to Put Options Contingent Upon Corporate Action">
                <InputText
                  neutral={true}
                  // placeholder="salutation"
                  value={
                    accountInformation.permissions.allowRespondingToPutOptionsContingentUponCorporateAction
                      ? "Yes"
                      : "No"
                  }
                  // setValue={setName}
                  disabled={true}
                />
              </Field>
            </div>
            <div className="flex flex-col px-1 md:px-2">
              <Field label="Allow Responding to Put Options Not Contingent Upon Corporate Action">
                <InputText
                  neutral={true}
                  // placeholder="salutation"
                  value={
                    accountInformation.permissions.allowRespondingToPutOptionsNotContingentUponCorporateAction
                      ? "Yes"
                      : "No"
                  }
                  // setValue={setName}
                  disabled={true}
                />
              </Field>
            </div>
            <div className="flex flex-col px-1 md:px-2">
              <Field label="Allow Other Elections By Bond Holders">
                <InputText
                  neutral={true}
                  // placeholder="salutation"
                  value={accountInformation.permissions.allowOtherElectionsByBondHolders ? "Yes" : "No"}
                  // setValue={setName}
                  disabled={true}
                />
              </Field>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
